module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Print Cash Report #{id}":"Print Cash Report #{id}","Print Cash Report \\\\#{id}":"Print Cash Report \\\\#{id}"},"de":{"Print Cash Report #{id}":"Kassenabschluss #{id} drucken","Cash Report":"Kassenabschluss","Could not print the cash report PDF!":"Kassenabschluss PDF konnte nicht gedruckt werden!"}}')
  delete Component.options._Ctor
}
